import {gql} from '@apollo/client';

const UPDATE_PARTNER = gql`
  mutation updateBusPartner(
    $id: ID!
    $name: String!
    $countryId: ID!
    $mobilityPartnerId: ID
    $depots: [BusPartnerDepotInput]
  ) {
    updateBusPartner(
      input: {
        id: $id
        name: $name
        countryId: $countryId
        mobilityPartnerId: $mobilityPartnerId
        depots: $depots
      }
    ) {
      id
      name
      mobilityPartnerId
      countryId
      currency
      status
      source
      depots {
        city
        postCode
        street
      }
    }
  }
`;

export default UPDATE_PARTNER;
